import { Button } from "components/Button/Button";
import DatePicker from "components/DatePicker/DatePicker";
import { Loading } from "components/Loading/loading";
import { UserContext } from "components/ModalForm/ModalForm";
import { Position } from "components/Position/Position";
import { Textbox } from "components/Textbox/Textbox";
import { Time } from "components/Time/Time";
import { Toast } from "components/ToastShow/ToastAlert";
import { useContext, useEffect, useState } from "react";
import { ConvertiSolarDateToGregorianDate, trans } from "utils/helpers";
import { getMeetingApprovalById, sendMeetingApproval } from "./api";
import { MessageType } from "types/enum";
import { CheckableButton } from "components/CheckableButton/CheckableButton";

interface MeetingApprovalFormPropsType {
  onHide?: () => void;
  handleShowReferenceStepper?: (referenceId: string) => void;
  referenceId?: string;
  MeetingId?: string;
  Description?: string;
  ApprovalId?: any;
  reset?:any;
  mode;
  processId?: any;
}
export const MeetingApprovalForm = ({
  reset,
  referenceId,
  MeetingId,
  ApprovalId,
  Description,
  mode,
  onHide,
  handleShowReferenceStepper,
  processId,
}: MeetingApprovalFormPropsType) => {
  let MeetingApprovalDTO: any;

  const [showReferenceStepper, setShowReferenceStepper] =
    useState<boolean>(false);

  const [resetForm, setResetForm] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [response, setResponse] = useState<any>();
  const [position, setPosition] = useState<any>();

  const [userMadeChanges, setUserMadeChanges] = useContext(UserContext);

  const [fromDate, setFromDate] = useState<string>();

  async function getMeetingApprovalAsync() {
    setLoading(false);
    try {
      if (ApprovalId) {
        const res = await getMeetingApprovalById(ApprovalId?.Id);
        setResponse(res.Data);
      } else if (referenceId) {
      }
    } catch (error) {}
    setLoading(true);
  }

  useEffect(() => {
    if (mode != "create" || (ApprovalId && ApprovalId?.length > 0)) {
      if ((referenceId || ApprovalId) && !showReferenceStepper)
        getMeetingApprovalAsync();
    }
  }, [referenceId, ApprovalId]);

  const handleonHideMeetingApprovalFormSubmit = (event) => {
    event.preventDefault();
    if (mode == "edit") {
      let data = {
        Id: response?.Id,
        MeetingId: response?.MeetingId,
        Description: event.target?.Description?.value,
        ApprovalNo: response?.ApprovalNo,
        IsExecutable: position?.Id?true:false,
        PerformerPositionId: position?.Id,
        PerformerPositionDescription: position?.Name,
        TaskDescription: event.target.TaskDescription.value,
        EstimateTime: +event.target.estimateTime[0].value,

        DeadlineTime: fromDate,
      };
      sendDataAsync(data, "put");
    } else {
      let data = {
        MeetingId: MeetingId,
        PerformerPositionId: position?.Id,
        PerformerPositionDescription: position?.Name,
        Description: event.target?.Description?.value,
        TaskDescription: event.target.TaskDescription.value,
        EstimateTime: +event.target.estimateTime[0].value,
        IsExecutable:position?.Id?true:false,
        DeadlineTime: fromDate,
      };
      sendDataAsync(data, "post");
    }
  };


  async function sendDataAsync(data, method) {
    try {
      const res = await sendMeetingApproval(data, method, processId);
      reset();
     onHide && onHide();
    } catch (err: any) {}
  }

  return (
    <>
      <div>
        {loading ? (
          <form
            action=""
            onSubmit={handleonHideMeetingApprovalFormSubmit}
            className={"p-2 "}
          >
            <div className="card ">
              <div className="card-body">
                <div className="row">
                  <div className="col-12">
                    <Textbox
                      required={true}
                      minHeight={mode == "view" ? 3 : 4}
                      Change={setUserMadeChanges}
                      textboxType="textarea"
                      labelText="Description"
                      resetForm={resetForm}
                      textboxName="Description"
                      defaultValue={ApprovalId?.Description}
                      mode={mode}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-4  mb-sm-0">
                    <Position
                      name="PerformerPositionId"
                      Change={setUserMadeChanges}
                      label="Performer"
                      resetForm={resetForm}
                      returnObj={true}
                      onChange={(e) => {
                        setPosition(e);
                      }}
                      value={
                        ApprovalId?.PerformerPositionId
                          ? ApprovalId?.PerformerPositionId
                          : null
                      }
                      mode={mode}
                    />
                  </div>
                  <div className="col-4 my-1 my-lg-0 col-lg-3">
                    <DatePicker
                      onOpenPickNewDate={false}
                      lable="DeadLineDate"
                      resetForm={resetForm}
                      type="date"
                                           mode={mode}

                      setIsoTime={(isoTime: string) => {
                        setFromDate(isoTime);
                      }}
                      val={
                        ApprovalId?.DeadlineTime
                          ? ConvertiSolarDateToGregorianDate(
                              ApprovalId?.DeadlineTime
                            ).toISOString()
                          : null
                      }
                    />
                  </div>

                  <div className="col-4 my-1 my-lg-0 col-lg-3">
                    <Time
                      name="estimateTime"
                      IdString="estimateTime"
                      resetForm={resetForm}
                      defaultValue={ApprovalId?.EstimateTime}
                      label="estimateTime"
                      mode={mode}

                    />
                  </div>
                  {/* <div className="col-4 my-1 my-lg-0 col-lg-3">
                    <CheckableButton
                      defaultChecked={true}
                      defaultValue={true}
                      labelText={"IsExecutable"}
                      inputName={"IsExecutable"}
                      type="checkbox"
                      mode="view"
                    />
                  </div> */}
                  <div className="col-12">
                    <Textbox
                      minHeight={mode == "view" ? 3 : 4}
                      Change={setUserMadeChanges}
                      textboxType="textarea"
                      labelText="TaskDescription"
                      resetForm={resetForm}
                      textboxName="TaskDescription"
                      defaultValue={ApprovalId?.TaskDescription}
                      mode={mode}
                    />
                  </div>
                </div>
              </div>
            </div>

            {mode != "view" ? (
              <div className="d-flex justify-content-end">
                {!Description && <Button btnType="submit" value="save" />}
                {handleShowReferenceStepper && (
                  <Button
                    btnType="submit"
                    value="SaveAndReference"
                    onClick={() => setShowReferenceStepper(true)}
                  />
                )}
                <Button
                  btnType="cancel"
                  value="cancel"
                  onClick={() => {
                    userMadeChanges
                      ? //  Toast(trans("modalclosemessage"), "warning", "alert", onHide)
                        Toast(
                          trans("modalclosemessage"),
                          MessageType.confirm,
                          onHide
                        )
                      :onHide && onHide();
                  }}
                />
              </div>
            ) : (
              <></>
            )}
          </form>
        ) : (
          <Loading />
        )}
      </div>
    </>
  );
};
